// This is a subreducer of widgetConfigReducer, responsible for the user settings of individual widgets, both general and special to a specific widget type
import { actionsTypes as types } from "../actions/widgetConfigActions";

const INITIAL_STATE = {};

const widgetSettingsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_WIDGET_SETTINGS_PROP:
      var { 
        //widgetid, 
        key, 
        val } = action;
      return {
        ...state,
        [key]: val
      };

    default:
      return state;
  }
};

export default widgetSettingsReducer;
